import React from "react";
import { ReactComponent as SvgLogoName } from "@/assets/logo-name.svg";
import { ReactComponent as SvgLogoCn } from "@/assets/logo-cn.svg";
import UserSettings from "./user-settings";
import LangPicker from "./lang-picker";
import "./index.less";

type IPageHeaderProps = {
  showLang?: boolean;
};

const PageHeader: React.FC<IPageHeaderProps> = ({ showLang = true }) => {
  return (
    <div className="section page-header">
      {process.env.API_LOCATION === "cn" ? <SvgLogoCn className="logo" /> : <SvgLogoName className="logo" />}
      <div className="header-right">
        {showLang && <LangPicker />}
        <UserSettings />
      </div>
    </div>
  );
};

export default PageHeader;
